// extracted by mini-css-extract-plugin
export default {"GoogleMap":"GoogleMap_GoogleMap__kXjvh","TripCalculation":"GoogleMap_TripCalculation__p4GXo"};